export default {
  type: 'menu',
  code: '18000000'
}
